import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import get from 'lodash/get'
import api from '../../api'
import { devicesSchema } from '../normalizr'
import { useAsyncAction } from '../utils'
import createSlice from '../create-slice'
import { getEntities } from './entities'

const devicesInitialState = {
  patients: {},
}

const devicesSlice = createSlice({
  name: 'devices',
  initialState: devicesInitialState,
  reducers: {
    setDevices: (state, { payload: { patientId, result } }) => {
      state.patients[patientId] = state.patients[patientId] || {}
      state.patients[patientId].ids = result
    },
  },
})

const { actions } = devicesSlice
const selectState = state => state[devicesSlice.name]

export function useDevices(patientId) {
  const { patients } = useSelector(selectState)
  const entities = useSelector(getEntities)
  return denormalize(
    get(patients, [patientId, 'ids'], []),
    [devicesSchema],
    entities,
  )
}

export function fetchDevices(patientId) {
  return async dispatch => {
    const res = await api.devices.getDevices({ patientId })
    dispatch(
      actions.setDevices({
        patientId,
        ...normalize(res, [devicesSchema]),
      }),
    )
  }
}

export function useFetchDevices(patientId) {
  return useAsyncAction(fetchDevices, patientId)
}

export default devicesSlice
